import React from 'react'
import insta from "../../assets/images/insta.svg"
import fb from "../../assets/images/fb.svg"
import wts from "../../assets/images/wts.svg"
import tube from "../../assets/images/tube.svg"
import { Link } from 'react-router-dom'
import { COMMBITZ_URL } from '../../config'
import styles from "./style/style.module.css"

function CopyRight() {
    return (

        <div className={styles.copyright}>
            <div className='row align-items-center'>
                <div className='col-md-8'>
                    <div className={styles.copyleft}>
                        <ul>
                            <p>COMMBITZ 2025 All Rights Reserved</p>
                            <li><a href="#">Privacy Policy</a></li>
                            <li><a href="#">Term & Condition</a></li>
                        </ul>
                    </div>
                </div>
                <div className='col-md-4'>
                    <div className={styles.copyRight}>
                        <ul>
                            <div className={styles.copyRight}>
                                <ul>
                                    <li><a href='https://www.linkedin.com/company/commbitz/' target="_blank" rel="noopener noreferrer"><img width="14" height="14" src={fb} alt="" /></a></li>
                                    <li><a href="https://www.instagram.com/commbitz_esim/?hl=en" target="_blank" rel="noopener noreferrer"><img width="14" height="14" src={insta} alt="" /></a></li>
                                    <li><a href="https://www.youtube.com/@Commbitz_esim" target="_blank" rel="noopener noreferrer"><img width="14" height="14" src={wts} alt="" /></a></li>
                                    <li><a href="https://www.facebook.com/commbizesim" target="_blank" rel="noopener noreferrer"><img width="14" height="14" src={tube} alt="" /></a></li>
                                </ul>
                            </div>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CopyRight